/*
export default {
  init() {
    const jQueryaddToCartForm = jQuery('#zd-product__single__form');

    if (!jQueryaddToCartForm.length) return
    const customFields = jQueryaddToCartForm.find('.wapf-input:not([type=hidden])')
    const submit = jQuery(jQueryaddToCartForm).find(':submit')

    if (customFields.length && submit.length) {
      this.handleRequiredCustomFields(customFields, submit)
      jQuery(customFields).on('input change', () => {
        setTimeout(() => {
          this.handleRequiredCustomFields(customFields, submit)
        }, 0);
      })
    }

    jQuery('body').on( 'added_to_cart', (event, fragments, cart_hash, jQuerybutton) => {
      const jQuerycheckoutBtn = jQuerybutton.siblings('.zd-to-checkout:first')
      if (jQuerycheckoutBtn.length) return
      jQuerybutton.after('<div id="zd-to-checkout" class="zd-to-checkout"><a class="btn btn-outline-secondary" href="/checkout">Checkout</a></div>')

        jQueryaddToCartForm.one('input keyup change paste', 'input, select, button', () => {
          const jQueryaddedBtn = jQuerybutton.siblings('.zd-to-checkout:first')

          jQueryaddedBtn.hide('fast', () => {
            jQueryaddedBtn.remove()
          })

          // jQueryaddToCartForm.find('#zd-to-checkout').hide('fast').remove()
        })

    })
  },
  handleRequiredCustomFields(fields, submit) {
      const invalidRequiredFields = fields.filter(function() {
        return jQuery(this).data('isRequired') === 1 && !this.validity.valid
      })

      if (invalidRequiredFields.length) {
        jQuery(submit).addClass('zd-custom-disabled').attr('disabled', true)
      } else {
        jQuery(submit).removeClass('zd-custom-disabled').attr('disabled', false)
      }
  },
}
*/